import { Route, RouteConfig } from 'vue-router';
import { ActionPermissionEnum, PagePermissionEnum } from '@/types/enum/PermissionEnum';
import { SourceConfigEnum } from '@/types/enum/SourceConfigEnum';
import { ImportedFileStatus } from '@/types/enum/ImportedFileStatus';
import { ImporterTemplate } from '@/types/enum/ImporterTemplate';

const undueRoute = [
	{
		path: '/projet/:projectToken/indus',
		name: 'projectUndues',
		props: true,
		component: () => import(
			/* webpackChunkName: "undue" */
			'../../views/UndueList.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.UNDUE_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-undue',
			isConfigurationMandatory: true,
			params: {
				type: 'project'
			}
		}
	},
	{
		path: '/projet/:projectToken/indus/declaration',
		name: 'newProjectUndue',
		props: true,
		component: () => import(
			/* webpackChunkName: "undue" */
			'../../views/UndueCreate.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.UNDUE_ADD, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'add-undue',
			isConfigurationMandatory: true,
			params: {
				type: 'project'
			}
		}
	},
	{
		path: '/indus',
		name: 'undues',
		props: true,
		component: () => import(
			/* webpackChunkName: "undue" */
			'../../views/UndueList.vue'
			),
		meta: {
			can: PagePermissionEnum.UNDUE_LIST_AM,
			label: 'router.label.undues',
			subLabel: 'router.subLabel.undue_list',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/indus/declaration',
		name: 'undueAdd',
		props: true,
		component: () => import(
			'../../views/UndueCreateAM.vue'
			),
		meta: {
			can: PagePermissionEnum.UNDUE_ADD_AM,
			label: 'router.label.undues',
			subLabel: 'router.subLabel.undue_add',
			hiddenOnProjectRoute: true
		}
	},
	{
		path: '/imports/indus',
		name: 'undueImport',
		props: { type: 'undue' },
		component: () => import(
			'../../views/GenericImport.vue'
			),
		meta: {
			label: 'router.label.undues',
			subLabel: 'router.subLabel.undue_import',
			can: 'direct_import_undue',
			navigationConfigurationName: 'import_undue_accessmaster',
			hiddenOnProjectRoute: true,
			params: {
				type: 'undue',
				sourceConfig: SourceConfigEnum.ACCESS_MASTER,
				fileStatusDownload: ImportedFileStatus.ORIGINAL,
				template: ImporterTemplate.DEFAULT_TEMPLATE,
				download: ActionPermissionEnum.IMPORT_UNDUE_DOWNLOAD
			}
		}
	}
] as RouteConfig[];

export default undueRoute;
